import React from 'react';
import PropTypes from 'prop-types';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../../../components/_styledComponents/MDBDropdownToggle';
import SvgIcon from '../icons/SvgIcon';
import {
  StyledMDBDropdown, DropdownItem, IconWrapper, DropdownText,
} from './css';

const ActionsMenu = (props) => {
  const { options } = props;

  const checkStickyColumn = (e) => {
    if (typeof document !== 'undefined') {
      const actionsMenuCollection = document.querySelectorAll('.actions-menu');
      actionsMenuCollection.forEach((item) => {
        const cellEl = item.closest('td');
        cellEl.style.zIndex = 2;
      });
      const obj = e.target;
      const objCell = obj.closest('td');
      objCell.style.zIndex = 3;
    }
  };

  return (
    <StyledMDBDropdown className="dropdown actions-menu">
      <MDBDropdownToggle className="border-0" onClick={(e) => checkStickyColumn(e)}>
        <SvgIcon icon="ThreeDotsIcon" />
      </MDBDropdownToggle>
      <StyledMDBDropdownMenu className="text-white bg-dark" basic>
        { options && options.filter((item) => item.visible).map((item, index) => (
          <DropdownItem key={index} disabled={item.disabled} onClick={item.action}>
            <IconWrapper>
              <SvgIcon icon={item.icon} />
            </IconWrapper>
            <DropdownText>{item.label}</DropdownText>
          </DropdownItem>
        ))}

      </StyledMDBDropdownMenu>
    </StyledMDBDropdown>
  );
};

ActionsMenu.propTypes = {
  options: PropTypes.array,
};

export default ActionsMenu;
